import classNames from 'classnames';
import { DateTime } from 'luxon';
import React, { useEffect, useMemo } from 'react';

const formatter = new Intl.NumberFormat('es-CL').format

const parsedNumber = (number) => {
    return isNaN(number) ? 0 : parseInt(number);
}

function TableRow({description, amount, price, discount = false, scheduleType}) {
    return (
        <tr>
            <td>
                {description}
                {amount > 1 && <span className='text-gray-500 ml-3'>({amount} x $ {formatter(parsedNumber(price))})</span>}
            </td>
            {
                scheduleType ?
                <td className='text-right'>{scheduleType.description}</td>
                :
            <td className='text-right'>{discount && '-'} $ {formatter(parsedNumber(amount < 1 || !amount ? price : price * amount))}</td>
            }
        </tr>
    )
}

export default function OrderStatus({
    date,
    time = '00:00',
    quantity,
    scheduleType,
    price,
    order = null,
    discountPercent = null,
    productsDetails,
    couponDiscountTotalWithProducts,
    office,
    isBulkOrder = false,
    onPrices = () => {},
    isProductOrder,
    ...props
}) {

    const getTotalPercent = (total, discountPercent) => {
        try {
            return total * discountPercent / 100;
        } catch (error) {
            return 0;
        }
    }

    const formatedDate = useMemo(() => {
        return isNaN(DateTime.fromFormat(time, 'HH:mm')) ? DateTime.fromFormat(time, 'H:mm') : DateTime.fromFormat(time, 'HH:mm')
    }, [time])



    const productsTotalPrice = useMemo(() => productsDetails.reduce((acc, item) => acc + item.totalPrice, 0), [productsDetails])
    const total = useMemo(() => (parsedNumber(quantity * price)), [quantity, price]);
    const totalPercent = useMemo(() => parsedNumber(couponDiscountTotalWithProducts ? getTotalPercent((total + productsTotalPrice), discountPercent) : getTotalPercent((total), discountPercent)), [total, discountPercent, productsTotalPrice]);
    // const totalPercent = useMemo(() => discountPercent ? (total * discountPercent) / 100 : 0, [total, discountPercent]);
    const totalWithDiscount = useMemo(() => parsedNumber(couponDiscountTotalWithProducts ? (total + productsTotalPrice) - totalPercent : (total - totalPercent) + productsTotalPrice), [total, totalPercent, productsTotalPrice]);

    useEffect(() => {
        onPrices && onPrices({productsTotalPrice, total, totalPercent, totalWithDiscount});
    }, [productsTotalPrice, total, totalPercent, totalWithDiscount])

    return (
        <div className={classNames("w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg", props?.className)}>

            <h2 className='mb-3 text-gray-900 text-lg font-bold'>Pedido</h2>

            <table className='w-full'>
                <tbody>
                    <tr>
                        <td>Sucursal</td>
                        <td className='text-right'>{office.name}</td>
                    </tr>
                    <tr>
                        <td>Dirección</td>
                        <td className='text-right'>{office.address}</td>
                    </tr>
                    <tr>
                        <td>Fecha</td>
                        <td className='text-right'>{date}</td>
                    </tr>
                    {
                        isProductOrder && (
                            <tr>
                                <td className=''>Hora</td>
                                <td className='text-right'>{formatedDate.plus({ hours: 0 }).toFormat('HH:mm')} hrs.</td>
                            </tr>
                        )
                    }
                    {scheduleType?.duration > 0 && (
                        <>
                            <tr>
                                <td className=''>Hora de inicio</td>
                                <td className='text-right'>{formatedDate.plus({ hours: 0 }).toFormat('HH:mm')} hrs.</td>
                            </tr>
                            <tr className={order ? '' : 'border-b-2'}>
                                <td className=''>Hora de término</td>
                                <td className='text-right'>{formatedDate.plus({ hours: scheduleType.duration }).toFormat('HH:mm')} hrs.</td>
                            </tr>
                        </>
                    )}
                    {
                        order &&
                        <tr className='border-b-2'>
                            <td className=''>Número de orden</td>
                            <td className='text-right'>{order}</td>
                        </tr>
                    }
                    {!isBulkOrder && !isProductOrder && (
                        <TableRow description='Tickets' amount={quantity} price={price}/>
                    )}
                    {
                        !isProductOrder && (
                            <TableRow description="Descripción" scheduleType={scheduleType} />
                        )
                    }
                    {!isBulkOrder && productsDetails?.map(({ product_id, name, price, quantity }, index) => (
                        <React.Fragment key={`product-detail-table-row-item-${product_id}-${index}`}>{quantity > 0 &&
                            <TableRow description={name} amount={quantity} price={price}/>
                        }</React.Fragment>
                    ))}
                    {!isBulkOrder && (
                        <>
                            {!isProductOrder && (
                                <TableRow description='Descuento' price={totalPercent} discount={true} />
                            )}
                            <tr className='border-t-2'>
                                <td>Total</td>
                                <td className='text-right font-bold'>
                                    {totalWithDiscount === 0 ? '$ 0' : `$ ${formatter(totalWithDiscount)}`}
                                </td>
                            </tr>
                        </>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export {formatter};
